import { LogActivityMutation } from 'API';
import { API, Auth, Hub } from 'aws-amplify';
import { logActivity } from 'graphql/mutations';
import { createContext, useContext, useEffect, useState } from 'react';
import APIContext from './APIContext';

interface ICognitoUser {
  attributes: any;
  username: any;
  signInUserSession: {
    idToken: {
      payload: {
        email: any;
        family_name: any;
        name: any;
      };
    };
  };
}
export type NullableUser = ICognitoUser | null;
const AuthContext = createContext<{
  isAuthorized: boolean | null;
  user: NullableUser;
  userIsASolutionsArchitect: boolean;
  testUser: boolean;
  // userIsAProductChampion: boolean;
}>({
  isAuthorized: false,
  user: null,
  userIsASolutionsArchitect: false,
  testUser: false,
  // userIsAProductChampion: false,
});

export const AuthContextProvider = (props: any) => {
  const [isAuthorized, setIsAuthorized] = useState(null as boolean | null);
  const [user, setUser] = useState<NullableUser>(null);
  const { getEnvironment } = useContext(APIContext);
  const { REACT_APP_EXTERNAL_LINK } = process.env;

  // console.log(ioAddress);

  const logActivityMutation = async (userInfo: ICognitoUser) => {
    try {
      const mutation = (await API.graphql({
        query: logActivity,
        variables: {
          Username: userInfo.username,
          Action: 'LOGIN',
          Environment: getEnvironment,
          Service: 'OMG PORTAL',
          Url: window.location.href,
          // Ip: ajpi,
        },
        authMode: 'AWS_IAM',
      })) as { data: LogActivityMutation };

      setUser(userInfo);
      setIsAuthorized(true);

      return true;
    } catch (e) {
      console.error('Error logging activity', e);
    }
  };
  const reactAppExternalLink = REACT_APP_EXTERNAL_LINK;

  const redirectToExternalLink = (): void => {
    if (reactAppExternalLink !== null && reactAppExternalLink !== undefined) {
      if (
        window.location.search.includes('&omni=2#DK&platform=OMNI') ||
        window.location.href.includes('&omni=2#DK&platform=OMNI')
      ) {
        window.location.href = reactAppExternalLink;
      }
    }
  };

  useEffect(() => {
    if (window.location.href.includes('OMNI')) {
      const previousUrl = window.location.href;
      const urlWithoutPlatform = previousUrl !== null ? previousUrl.replace(`&omni=2#DK&platform=OMNI`, '') : '';
      localStorage.setItem('previousUrl', urlWithoutPlatform);
      redirectToExternalLink();
    } else {
      Hub.listen('auth', ({ payload: { event, data } }) => {
        switch (event) {
          case 'omni':
            break;
          // case "":
          // case 'signIn':
          case 'cognitoHostedUI':
            getUser().then((userData) => {
              /*  setUser(userData);  */ logActivityMutation(userData);
            });
            break;
          case 'signOut':
            setUser(null);

            break;
          case 'customOAuthState':
            if (data) {
              setTimeout(() => {
                if (data === 'Database') {
                  window.location.href = localStorage.getItem('previousUrl') as string;
                } else {
                  window.location.href = data;
                }
              }, 2000);
            }
            break;
          case 'signIn_failure':
          case 'cognitoHostedUI_failure':
            setIsAuthorized(false);
            break;
        }
      });
    }
  }, []);
  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => {
        setIsAuthorized(false);
      });
  };
  useEffect(() => {
    getUser().then((userData) => setUser(userData));
  }, []);
  // const [userIsAProductChampion, setUserIsAProductChampion] = useState<boolean>(false);
  const [userIsASolutionsArchitect, setUserIsASolutionsArchitect] = useState<boolean>(false);
  const testUser =
    user?.username === 'onewp_marko.zabrdac@annalect.com' || user?.username === 'onewp_lene.boelling@annalect.com';

  useEffect(() => {
    if (user) {
      setIsAuthorized(true);
      const solutionsArchitectEmails = [
        // 'marko.zabrdac@omc.com',
        // 'lene.boelling@omc.com',
        'tobias.kurland@omc.com',
        'morten.estrup@omc.com',
        'benjamin.agic@omc.com',
        'benjamin.bruun@omc.com',
        'ali.chouikhi@omc.com',
      ];
      console.log('USER IN AUTH CONTEXT', user.attributes.email);
      const isInSolutionsArchitectList = solutionsArchitectEmails.includes(user.attributes.email);
      setUserIsASolutionsArchitect(isInSolutionsArchitectList);
      // const productChampionEmails = [
      //   'daniel.mortensen@omd.com',
      //   'nicolai.graae@omd.com',
      //   'caroline.madsen@omd.com',
      //   'maria.christensen@omd.com',
      //   'clara.tuxen@omd.com',
      //   'emma.rohde@omd.com',
      //   'kristoffer.mydtskov@omd.com',
      //   'simon.rugaard@hearts-science.com',
      //   'malene.dahl@phdmedia.com',
      //   'ole.thonesen@phdmedia.com',
      //   'jimmy.stromberg@omnicommediagroup.com',
      //   'patrik.stenberg@phdmedia.com',
      //   'jonas.johnsson@omd.com',
      //   'albin.batelsson@phdmedia.com',
      //   'alexander.ek@phdmedia.com',
      //   'zagreb.start.gmail.com',
      //   'lenelaudrupboelling.gmail.com',
      //   'marko.zabrdac@annalect.com',
      //   'lene.boelling@annalect.com',
      // ];

      // const splitUsername = user.username.split('_')[1]?.split('@')[0] ?? '';

      // const isInProductChampionList = productChampionEmails.some(
      //   (email) =>
      //     email.startsWith(splitUsername) ||
      //     user.username.startsWith('zagreb.start.gmail.com') ||
      //     user.username.startsWith('lenelaudrupboelling.gmail.com'),
      // );

      // const userEmail = user.attributes?.email || user.signInUserSession?.idToken?.payload?.email || '';
      // const isAnnalectUser = userEmail.endsWith('@anjjjnalect.com');

      // const isProductChampion = isInProductChampionList || isAnnalectUser;
      // setUserIsAProductChampion(isProductChampion);
    }
  }, [user]);

  return (
    <AuthContext.Provider
      value={{
        isAuthorized,
        user,
        userIsASolutionsArchitect,
        testUser,
        // userIsAProductChampion,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};
export default AuthContext;
